var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStakestone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7565_2410)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z",
    fill: "#06070A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4037 16.7901L22.6528 30.1815",
    stroke: "white",
    strokeWidth: 1.82762
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4347 28.9709L16.7324 24.625L21.916 29.9233L33.4803 27.3425L39.7832 29.7545L24.9976 42L10.4347 28.9709Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7565_2410",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 24,
    width: 30,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4347 28.9709L16.7324 24.625L21.916 29.9233L33.4803 27.3425L39.7832 29.7545L24.9976 42L10.4347 28.9709Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7565_2410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6528 29.3951L24.9976 42",
    stroke: "black",
    strokeWidth: 1.82762
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9901 8L16.7324 14.5945L10 28.4637L24.9901 42L40 29.5388L32.0751 12.5352L24.9901 8Z",
    stroke: "white",
    strokeWidth: 1.82762
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7324 14.5945L24.2269 16.7901L32.0751 12.5352",
    stroke: "white",
    strokeWidth: 1.82762
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7565_2410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakestone);
export default __webpack_public_path__ + "static/media/Stakestone.466f6b6a6fb188fbbc6c1c685fc1aebf.svg";
export { ForwardRef as ReactComponent };